/**
 * A site page of prose: the terms, the privacy notice, the page about the site.
 * The Bulgarian is authoritative; the English says it is a translation. The
 * date is the content file's last change, from git at build time.
 */

import type { ReactNode } from 'react'
import dates from 'virtual:content-dates'
import { useI18n } from '../i18n/index.tsx'
import type { MessageKey } from '../../shared/message-keys.ts'
import { fill } from '../lib/catalogue.ts'
import { usePageTitle } from './Catalogue.tsx'

export function ContentPage({
  titleKey,
  page,
  bg,
  en,
}: {
  titleKey: MessageKey
  page: keyof typeof dates
  bg: ReactNode
  en: ReactNode
}) {
  const { t, locale } = useI18n()
  usePageTitle(t(titleKey))
  const updated = new Intl.DateTimeFormat(locale === 'bg' ? 'bg-BG' : 'en-GB', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    timeZone: 'Europe/Sofia',
  }).format(new Date(`${dates[page]}T12:00:00Z`))

  return (
    <article className="content-page">
      <h1>{t(titleKey)}</h1>
      <p className="content-page__updated">{fill(t('content.updated'), { date: updated })}</p>
      {locale === 'en' ? <p className="content-page__note">{t('content.translation')}</p> : null}
      {locale === 'bg' ? bg : en}
    </article>
  )
}
